import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    Email: "",
    Message: "",
  });

  const [resultMessage, setResultMessage] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Email validation
    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailValid.test(formData.Email)) {
      alert("Please enter a valid email address");
      return;
    }


    // Send to Web3Forms
    const web3formsData = {
      access_key: "c96c8932-1f1a-4891-b271-1e3d4212ed4c", // replace this
      name: formData.name,
      email: formData.Email,
      message: formData.Message,
    };

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(web3formsData),
      });

      const data = await response.json();

      if (data.success) {
        setResultMessage("We have received your message. Our team will respond to you within 1-2 business days.");
        e.target.reset();
        setFormData({
          name: "",
          Email: "",
          Message: "",
        });
      } else {
        setResultMessage(`Error: ${data.message}`);
      }
    } catch (error) {
      setResultMessage("An error occurred during submission. Please make changes and try again.");
    }
  };

  return (
    <section id="contact" className="contact">
      <h2>Contact Me</h2>
      <form className="contact-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="Email"
          placeholder="Your Email"
          value={formData.Email}
          onChange={handleChange}
          required
        />
        <textarea
          name="Message"
          placeholder="You can send us a message, and we will get back to you as soon as possible."
          rows="1.5"
          value={formData.Message}
          onChange={handleChange}
          required
        />
        <button type="submit">Send</button>
      </form>

      {resultMessage && (
        <p className="contact-success">{resultMessage}</p>
      )}
    </section>
  );
};

export default Contact;
